import { CSSProperties, FunctionComponent, HTMLAttributes, ReactNode } from 'react';
import { cssVars as palette } from '../../theme/cssVars';

type AvatarUIProps = {
  src?: string,
  alt?: string,
  children?: ReactNode,
} & HTMLAttributes<HTMLDivElement>;

// MUI Avatar: 40x40 circle, grey[400] fallback bg, white text; renders <img> when
// `src` is set, else children (initials/icon). Base inline so call-site style
// (size, backgroundColor) overrides under `important: '#root'`.
const AvatarUI: FunctionComponent<AvatarUIProps> = ({ src, alt, className = '', style, children, ...rest }) => {
  const baseStyle: CSSProperties = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: 40,
    height: 40,
    borderRadius: '50%',
    overflow: 'hidden',
    userSelect: 'none',
    fontSize: '1.25rem',
    lineHeight: 1,
    backgroundColor: '#bdbdbd', // MUI grey[400] fallback — no design token match, one-off
    color: palette.backgroundPaper,
    ...style,
  };

  return (
    <div className={className} style={baseStyle} {...rest}>
      {src
        ? <img src={src} alt={alt} style={{ width: '100%', height: '100%', objectFit: 'cover', color: 'transparent', textAlign: 'center' }} />
        : children}
    </div>
  );
};

export default AvatarUI;
